import { render, staticRenderFns } from "./Clasy.vue?vue&type=template&id=2eb4d1c0&scoped=true&"
import script from "./Clasy.vue?vue&type=script&lang=js&"
export * from "./Clasy.vue?vue&type=script&lang=js&"
import style0 from "./Clasy.vue?vue&type=style&index=0&id=2eb4d1c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb4d1c0",
  null
  
)

export default component.exports